import { useQuery } from "@tanstack/react-query";
import { useApi } from "@csa/web-foundation";

/**
 * WHICH BRANCHES CAN WE ACTUALLY QUOTE — from the catalog, not from a literal.
 *
 * THE DEFECT. Four surfaces each kept their own hardcoded line list and they
 * disagreed: Öneri offered 2 (trafik, kasko), phone intake 5, web intake 5,
 * prepare-offers 7 — while the catalog defines 7 and the seed authorises all of
 * them for all three pilot carriers. So "which branch may I quote?" had four
 * different answers depending on which screen the advisor happened to open, and
 * none of them was the system's answer.
 *
 * Worse, two of those lists use `saglik`, which is NOT a catalog line code at
 * all (the taxonomy has `tss` and `oss`). That one is a genuine mismatch rather
 * than a breadth difference, and it is recorded separately — fixing it changes a
 * request contract shared by apps/web, so it does not belong in this change.
 *
 * The server now answers once: GET /v1/distribution/open-lines applies the SAME
 * three legs as the offer gate (branch authorization ∧ panel ACTIVE ∧ open
 * agreement). When a line opens because the panel opened, the picker gains it
 * with NO UI change — which is the actual requirement.
 */
export interface OpenLine {
  lineCode: string;
  open: boolean;
  carrierCount: number;
  /** Why a closed line is closed, in the offer gate's own vocabulary. */
  reason: string | null;
}

export function useOpenLines() {
  const api = useApi();
  return useQuery({
    queryKey: ["distribution", "open-lines"],
    // The panel/agreement state changes at governance speed, not request speed.
    staleTime: 5 * 60_000,
    retry: false,
    queryFn: () => api.get<OpenLine[]>("/v1/distribution/open-lines"),
  });
}
